import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {API_URLS} from "@/utils/constants/api-urls.ts";
import {AfterFetchContext} from "@vueuse/core";
import {ICreatePaymentRequest, IGetResult, IPayment, IUser} from "@/types/api.ts";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";

export class PaymentService {

  static getInstance(): PaymentService {
    return new PaymentService();
  }

  async createPayment(body: ICreatePaymentRequest): Promise<void> {
    const {execute, data} = useAxios<IGetResult>(API_URLS.payments.create, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }

  getPayments() {
    return useFactoryFetch(API_URLS.payments.list, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.payments}
      }
    }).json();
  }

  getCurrentStudentPayments() {
    return useFactoryFetch(API_URLS.payments.getCurrentStudentPayments, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.studentPayments}
      }
    }).json();
  }

  async getStudentPayments(student: IUser) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.payments.getStudentPayments(student._id), {
      method: "get"
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.studentPayments;
  }

  async deletePayment(payment: IPayment) {
    const {execute} = useAxios<IGetResult>(API_URLS.payments.deleteById(payment._id), {
      method: "DELETE",
    }, axiosInstance, {immediate: false})
    await execute();
  }

  async updatePayments(payments: IPayment[]) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.payments.updateMany, {
      method: "PATCH",
      data: {payments}
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }
}